module.exports = require("codemirror/mode/yaml/yaml");